const { appendFilter } = require('../../../queries');
const addDdasQueries = require('../../../queries/configs/Ddas');

module.exports = addDdasQueries(function ({ payerId, baseUrl }) {
  return ({
    baseUrl: `${baseUrl}/${payerId}/ddas`,
    queriesFilter: appendFilter('payerId', payerId),
  })
});
